module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-title",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-a.jpg"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photographing the War on the Water")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_vm._v("by Chris Heisey")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("June 2022 marks 50 years since I began reading everything I could about our Civil War. My learning began just after my memorable first visit to Gettysburg in June 1972 as Hurricane Agnes dumped feet of rain to completely flood the sacred soil that long ago summer. I must admit, though that deluge of water was my baptism into Civil War study, I ironically have read very little about vital naval operations in the Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I was a kid, water was a constant source of my recreation. Every summer, my two-day beach trip to New Jersey was a cherished vacation of floating upon the chilly waves as the July sun sizzled my hide like fried bacon. A good sunburn was proof of being battle-tested at the beach back in those days before we knew better. When you returned to the small-town community pool, peeling like an onion, your friends knew you had done a heroic tour at sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, too, did I grow up near two water-filled quarries where we built ships out of wood and sank them with rocks as we were perilously perched high atop the rocky bluffs. It was dangerous work, but every ship had to be sunk no matter the risk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In winter, we played pond hockey there till our toes froze or fingers did first. But we never quit until a winner was had and losers went home with a score to settle on another soon-frigid night when we would play again under the faint light of flashlights and candles tied to the rocks. Games were always a battle to be won.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Water has always earned a respectful fascination, so it is quite odd I have never made it my Civil War desire to study the great naval campaigns of the war. Maybe it’s time to make room in my head for the epic clash of "), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monitor")]), _vm._v(" and CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" and study ironclad warfare of the 1860s. Or perhaps it also time to learn about the great battle for Alabama’s Mobile Bay in August 1864.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xxiii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionC"
  }, [_vm._v("Sullivan Island, outside Charleston, overlooking the area where the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hunley")]), _vm._v(" sank "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chris Heisey")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Certainly, it is also time to return to Fort Fisher near Wilmington, North Carolina, to see again where the Confederacy’s last viable port fell in January 1865 after a bloody fight on those sand parapets that face the Atlantic Ocean. Last time I was there, with camera and tripod in hand, a tropical storm was pummeling the beach with pushing surf and relentless rain. It remains the most challenging, most exhilarating Civil War photo shoot I have ever experienced. Had I not experienced water all through my youth and learned to respect the formidable almighty power it rightly has earned, I would never have been able to enjoy that battle where weather and water nearly got the best of me that not-so-long-ago June day at those hallowed North Carolina sands where the blue and gray fought so ferociously in the war’s ending days."), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  })]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xxiv-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionC"
  }, [_vm._v("Jekyll Island, Georgia, where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wanderer")]), _vm._v(" landed in November 1858 with the second-to-last shipment of slaves brought to America "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chris Heisey")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  })]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xxvi-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionC"
  }, [_vm._v("Morris Island, near the site of Battery Wagner "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chris Heisey")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  })]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "fig1",
      "src": "images/fxxviii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionC"
  }, [_vm._v("Remains of Fort Fisher, North Carolina "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chris Heisey")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xxx-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFSHORE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCKADES")]), _vm._v(" & C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OASTAL")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARBORS")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEATERS")]), _vm._v("—The blockade and coastal campaigns engaged the same naval forces but were fundamentally different operations. The United States Navy had never deployed such large formations, although the British Royal Navy supplied a robust tradition. The primary command unit was the squadron with from a few to hundreds of combat and support vessels under a single officer with the new rank of admiral. See page 80 for a map of the rivers theater, home of the Mississippi River Squadron.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648ea34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter01.vue
// module id = 87
// module chunks = 0